import React, { FC, useRef, useState } from 'react';
import {
  BlueArrowDown, BlueArrowUp, Button, List,
} from '@components';
import {
  IOnboardingData, OnboardingData, PageRoutes, ProfileRoutes, setClass, useOutsideClick, useViewModel,
} from '@utils';
import { useNavigate } from 'react-router-dom';
import { ProfileViewModel } from '@views';

interface OnboardingCalendarHelperProps {
  onboardingData: IOnboardingData | null
  imageIndex: number
  setImageIndex: (index: number) => void
  showSogoButton?: boolean
}

export const OnboardingCalendarHelper: FC<OnboardingCalendarHelperProps> = ({ onboardingData, imageIndex, setImageIndex, showSogoButton = false }) => {
  const navigate = useNavigate();
  const profileViewModel = useViewModel(ProfileViewModel);
  const buttonRef = useRef<HTMLDivElement>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const listRef = useOutsideClick(() => setMenuOpen(false));
  const topOfList = buttonRef.current?.getBoundingClientRect().top + 26;
  const rightOfList = window.innerWidth - buttonRef.current?.getBoundingClientRect().right - 253;

  const handleSelect = (url: string) => {
    setMenuOpen(false);
    navigate(`/onboarding/${url}`);
  };

  const handleNavigateToProfile = () => {
    profileViewModel.setRestoreNewCalendar(true);
    navigate(`${PageRoutes.PROFILE_PAGE}/${ProfileRoutes.CONNECTED_CALENDARS_TAB}`)
  };

  const handleNavigateToSogo = () => {
    window.open('https://webmail.relex.ru/SOGo/', '_blank').focus();
  };

  return (
    <>
      {onboardingData && (
        <div className="onboarding-wrapper tutorial">
          <div className="onboarding-header tutorial">
            <div>
              Синхронизация календаря
              <span className="onboarding-calendar-name">{` ${onboardingData.name}`}</span>
            </div>
            <div ref={buttonRef} onClick={() => setMenuOpen(true)}>
              {menuOpen ? (
                <BlueArrowUp />
              ) : (
                <BlueArrowDown divClassName="open-menu" />
              )}
            </div>
          </div>
          <img src={onboardingData.images[imageIndex]} className="onboarding-calendar-image" alt="" />
          {onboardingData.images.length > 1 && (
            <>
              <div className="onboarding-image-button-row">
                {onboardingData.images.map((img, index) => (
                  <Button
                    key={index}
                    className={setClass('onboarding-image-button', index !== imageIndex && 'outlined')}
                    onClick={() => setImageIndex(index)}
                  />
                ))}
              </div>
              {imageIndex < onboardingData.images.length - 1 && (
                <div className="onboarding-image-arrow-button next" onClick={() => setImageIndex(imageIndex + 1)} />
              )}
              {imageIndex > 0 && (
                <div className="onboarding-image-arrow-button previous" onClick={() => setImageIndex(imageIndex - 1)} />
              )}
            </>
          )}
          <div className="onboarding-button-container">
            <Button
              className="onboarding-close-button profile-button"
              onClick={handleNavigateToProfile}
              title="Перейти в профиль"
            />
            {showSogoButton && (
              <Button
                className="onboarding-close-button profile-button"
                onClick={handleNavigateToSogo}
                title="Перейти в SOGo"
              />
            )}
          </div>
          {menuOpen && (
            <div ref={listRef}>
              <List
                top={topOfList}
                right={rightOfList}
                items={OnboardingData}
                renderItem={(data: IOnboardingData) => (
                  <div
                    className={setClass('item', onboardingData.url === data.url && 'selected')}
                    onClick={() => handleSelect(data.url)}
                  >
                    {data.name}
                  </div>
                )}
                sortingRule={() => { return 0; }}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};
